var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"color":_vm.color,"small":"","label":""}},[_vm._v(" "+_vm._s(_vm.$t(`document_types.${_vm.item}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }